export const fullProfileTypes = {
    SET_PLAYER_ID: 'FULL_PROFILE_SET_PLAYER_ID',
};
